import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getClipboardData, isEmpty, pasteAsText } from '../../../../utils'
import { clear, removeSuggestions, setTexts } from '../keywordSlice'
import classNames from 'classnames'
import { CampaignTypes } from '../../../Codes'

const getFilteredTextContents = childNodes =>
  [...childNodes]
    .filter(item => item.contentEditable !== 'false')
    .map(item => {
      const textContent = item.textContent.includes('\n')
        ? item.textContent.split('\n')[0]
        : item.textContent
      return textContent.replaceAll(' ', ' ')
    })
    .filter(item => !isEmpty(item.trim()))

const AddKeywords = () => {
  const dispatch = useDispatch()
  const {
    campaign: {
      form: { campaignType },
    },
    keyword: {
      isSubmitting,
      form: { texts, suggestions },
    },
  } = useSelector(state => state.ad)
  const [keywordCount, setKeywordCount] = useState(
    texts.length + suggestions.length
  )
  const [focused, setFocused] = useState(false)
  const textAreaRef = useRef()

  useEffect(() => {
    setKeywordCount(texts.length + suggestions.length)
  }, [texts, suggestions])
  const convertDangerouslyHTML = textContents => {
    const keywords = textContents || texts
    const editable =
      keywords.length === 0 && suggestions.length > 0
        ? '<br>'
        : texts
            .map(
              item =>
                `<span class='txt_tag' contenteditable='true'>${item}</span>`
            )
            .join('')
    const uneditable = suggestions
      .map(
        item => `<span class='txt_tag' contenteditable='false'>
                    <span class='fc_emph'>${item}</span>
                    <button type='button' class='btn_del' data-id='${item}'>
                        <span class='ico_comm ico_del'>삭제</span>
                    </button>
                </span>`
      )
      .join('')
    return `${editable} ${uneditable}`
  }
  const handleKeywordsPaste = event => {
    event.preventDefault()
    const text = getClipboardData(event)
    pasteAsText(text)
  }
  const handleKeywordsInput = event => {
    const { childNodes } = event.target
    setKeywordCount(
      getFilteredTextContents(childNodes).length + suggestions.length
    )
  }
  const handleKeywordsKeyDown = event => {
    const { childNodes } = event.target
    const count =
      getFilteredTextContents(childNodes).length + suggestions.length
    const [firstChild, secondChild] = childNodes
    if (
      (firstChild?.nodeName === 'BR' || firstChild?.innerHTML === '<br>') &&
      secondChild?.nodeName === '#text' &&
      secondChild?.textContent === ' ' &&
      event.key === 'Backspace'
    ) {
      event.preventDefault()
    }
    setKeywordCount(count)
    if (count >= 300 && event.key === 'Enter') {
      event.preventDefault()
    }
  }
  const handleKeywordsFocus = () => {
    setFocused(true)
  }
  const handleKeywordsChange = event => {
    setFocused(false)
    if (textAreaRef.current && textAreaRef.current === event.target) {
      const { childNodes } = event.target
      const textContents = [
        ...new Set(
          getFilteredTextContents(childNodes).map(text =>
            campaignType === CampaignTypes.TALK_CHANNEL
              ? text.trim()
              : text.toLowerCase().replace(/\s+/g, '')
          )
        ),
      ]
      dispatch(setTexts(textContents))
      event.target.innerHTML = convertDangerouslyHTML(textContents)
    }
  }
  const handleReset = useCallback(() => dispatch(clear()), [dispatch])
  const deleteSuggestionsKeyword = useCallback(
    keyword => {
      dispatch(removeSuggestions(keyword))
    },
    [dispatch]
  )
  const handleDelete = event => {
    let el = event.target
    while (el && el !== event.currentTarget && el.className !== 'btn_del') {
      el = el.parentNode
    }
    if (el && el.className === 'btn_del') {
      event.stopPropagation()
      deleteSuggestionsKeyword(el.dataset.id)
    }
  }
  const handleFocus = () => {
    setFocused(true)
    textAreaRef.current?.focus()
  }
  return (
    <div
      className={classNames('box_keyword', {
        type_talkch: campaignType === CampaignTypes.TALK_CHANNEL,
      })}>
      <div className="item_head">
        등록 키워드 <span className="fc_emph">{keywordCount}</span>
        /300
      </div>
      <div className="item_body">
        <div className="box_textarea" onClick={handleFocus}>
          {focused === false && keywordCount === 0 && (
            <label htmlFor="tfArea1" className="lab_txt">
              한줄에 하나씩 입력하세요.
            </label>
          )}
          <div
            id="tfArea1"
            className="tf_area"
            contentEditable
            ref={textAreaRef}
            dangerouslySetInnerHTML={{
              __html: convertDangerouslyHTML(),
            }}
            onInput={handleKeywordsInput}
            onKeyDown={handleKeywordsKeyDown}
            onPaste={handleKeywordsPaste}
            onFocus={handleKeywordsFocus}
            onBlur={handleKeywordsChange}
            onClick={handleDelete}
          />
        </div>
        <button
          type="button"
          className="btn_refresh"
          onClick={handleReset}
          disabled={isSubmitting}>
          <span className="ico_comm" />
          초기화
        </button>
      </div>
    </div>
  )
}
export default AddKeywords
